import { useCallback, useState } from 'react';

import { useResetAtom } from 'jotai/utils';
import { diagnosisBaseAtom, diseaseAtom, kidneyAtom, gfrAtom, requestDiseaseAtom } from '../../components/diagnosis/atom';

const initalPayload = {
  relationType: null,
  gender: null,
  bornYear: null,
  height: null,
  weight: null,
  disease: null,
  kidney: {
    causesLowSalt: null,
    kidneyStatus: null,
    creatinineLevel: null,
    causesLowSaltInput: null,
    detailKidney: null
  },
  diabetes: {
    diabetesStatus: null,
    pregnantStatus: null,
    fbs: null,
    twoHrPg: null,
    glycosylatedHemoglobin: null
  },
  cancer: {
    weightChange: null,
    edemaOrAscites: null,
    anorexia: null,
    albumin: null,
    hemoglobin: null,
    cancerCategory: null,
    cancerCategoryInput: null,
    anotherDisease: null
  }
};

const usePayload = () => {
  const [payload, setPayload] = useState(initalPayload);

  const resetPayload = () => {
    setPayload(initalPayload);
  };

  const handleSelectionClick = (category, type, value) => () => {
    setPayload(state => {
      return {
        ...state,
        ...(category !== '' ? { [category]: { ...state[category], [type]: value } } : { [type]: value })
      };
    });
  };

  const handleInputBoxChange = (category, type) => event => {
    const newValue = event?.target?.value;
    setPayload(state => ({
      ...state,
      ...(category ? { [category]: { ...state[category], [type]: newValue } } : { [type]: newValue })
    }));
  };
  return { payload, setPayload, handleSelectionClick, handleInputBoxChange, resetPayload };
};

const useDiseaseArray = () => {
  const [diseaseArray, setDiseaseArray] = useState([]);
  const [diseaseSelections, setDiseaseSelections] = useState([]);

  //   타 질환 선택시 중복 선택 및 해당없음 표현 함수
  const handleSelectionDiseaseClick = useCallback(
    event => {
      event.preventDefault();
      const selectedValue = event.target.value;

      if (selectedValue !== 'none') {
        if (diseaseArray.indexOf('none') === 0) {
          diseaseArray.shift();
          setDiseaseArray([...diseaseArray, selectedValue]);
          setDiseaseSelections((diseaseSelections[diseaseSelections.length - 1].selected = false));
          setDiseaseSelections(diseaseSelections.map(selection => (selection.value === selectedValue ? { ...selection, selected: true } : selection)));
        } else {
          const index = diseaseArray.indexOf(selectedValue);
          if (index === -1) {
            setDiseaseArray([...diseaseArray, selectedValue]);
            setDiseaseSelections(diseaseSelections.map(selection => (selection.value === selectedValue ? { ...selection, selected: true } : selection)));
          } else {
            const newValues = [...diseaseArray];
            newValues.splice(index, 1);
            setDiseaseArray(newValues);
            setDiseaseSelections(diseaseSelections.map(selection => (selection.value === selectedValue ? { ...selection, selected: false } : selection)));
          }
        }
      } else {
        setDiseaseArray(['none']);
        setDiseaseSelections(diseaseSelections.map(selection => (selection.value === selectedValue ? { ...selection, selected: true } : { ...selection, selected: false })));
      }
    },
    [diseaseArray, diseaseSelections]
  );
  return { diseaseArray, diseaseSelections, setDiseaseSelections, handleSelectionDiseaseClick };
};

const useResetAllDiagnosis = () => {
  const resetDiagnsosBase = useResetAtom(diagnosisBaseAtom);
  const resetDisease = useResetAtom(diseaseAtom);
  const resetKidney = useResetAtom(kidneyAtom);
  const resetGfr = useResetAtom(gfrAtom);
  const resetRequestDisease = useResetAtom(requestDiseaseAtom);
  const resetAllDiagnosis = useCallback(() => {
    resetDiagnsosBase();
    resetDisease();
    resetKidney();
    resetGfr();
    resetRequestDisease();
  }, [resetDiagnsosBase, resetDisease, resetKidney, resetGfr, resetRequestDisease]);
  return resetAllDiagnosis;
};

export { usePayload, useDiseaseArray, useResetAllDiagnosis };
